import ProductGridBase from './ProductGridBase';
import { Product } from '../Product';
export const ProductGrid = {
  ProductGrid_1: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_1}
        productWidth={50}
      />
    );
  },
  ProductGrid_2: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_2}
        productWidth={50}
      />
    );
  },
  ProductGrid_3: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_3}
        productWidth={50}
      />
    );
  },
  ProductGrid_4: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_4}
        productWidth={50}
      />
    );
  },
  ProductGrid_5: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_5}
        productWidth={50}
      />
    );
  },
  ProductGrid_6: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_6}
        productWidth={50}
      />
    );
  },
  ProductGrid_7: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_7}
        productWidth={50}
      />
    );
  },
  ProductGrid_8: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_8}
        productWidth={50}
      />
    );
  },
  ProductGrid_9: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_9}
        productWidth={50}
      />
    );
  },
  ProductGrid_10: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_10}
        productWidth={50}
      />
    );
  },
  ProductGrid_11: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_11}
        productWidth={50}
      />
    );
  },
  ProductGrid_12: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_12}
        productWidth={50}
      />
    );
  },
  ProductGrid_13: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_13}
        productWidth={50}
      />
    );
  },
  ProductGrid_14: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_14}
        productWidth={50}
      />
    );
  },
  ProductGrid_15: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_15}
        productWidth={50}
      />
    );
  },
  ProductGrid_16: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_16}
        productWidth={50}
      />
    );
  },
  ProductGrid_17: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_17}
        productWidth={50}
      />
    );
  },
  ProductGrid_18: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_18}
        productWidth={50}
      />
    );
  },
  ProductGrid_19: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_19}
        productWidth={50}
      />
    );
  },
  ProductGrid_20: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_20}
        productWidth={50}
      />
    );
  },
  ProductGrid_21: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_21}
        productWidth={50}
      />
    );
  },

  ProductGrid_22: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_22}
        productWidth={50}
      />
    );
  },
  ProductGrid_23: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_23}
        productWidth={50}
      />
    );
  },
  ProductGrid_24: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_24}
        productWidth={50}
      />
    );
  },
  ProductGrid_25: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_25}
        productWidth={50}
      />
    );
  },
  ProductGrid_26: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_26}
        productWidth={50}
      />
    );
  },
  ProductGrid_27: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_27}
        productWidth={25}
      />
    );
  },
  ProductGrid_28: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_28}
        productWidth={50}
      />
    );
  },
  ProductGrid_Yenir_2: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_Yenir_2}
        productWidth={50}
      />
    );
  },
  ProductGrid_HicretKuruyemis: ({ item, activeThemePageId }) => {
    return (
      <ProductGridBase
        item={item}
        activeThemePageId={activeThemePageId}
        Product={Product?.Product_HicretKuruyemis}
        productWidth={50}
      />
    );
  },
};
